#import "../fragments/sms-drip-edition-fragment.graphql"

query GetSmsDripSequenceEditions($limit: Int!, $cursor: String, $dripSequenceId: ID!) {
    smsDripSequence(id: $dripSequenceId) {
        id
        editions(first: $limit, after: $cursor) {
            edges {
                cursor
                node {
                    ...SmsDripEditionFragment
                }
            }
        }
    }
}
